import { render } from "./EbooksView.vue?vue&type=template&id=4e9a4d2a&scoped=true"
import script from "./EbooksView.vue?vue&type=script&lang=js"
export * from "./EbooksView.vue?vue&type=script&lang=js"

import "./EbooksView.vue?vue&type=style&index=0&id=4e9a4d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9a4d2a"]])

export default __exports__